import store from '../store/store';
import { firebase } from '../config/configureFirebase';

const callBookingApi = async (path, method = 'GET', body) => {
  const currentUser = firebase.auth.currentUser;
  if (!currentUser) {
    throw new Error('AUTHENTICATION_REQUIRED');
  }
  const token = await currentUser.getIdToken();
  const settings = store.getState().settingsdata.settings || {};
  const configuredOrigin = settings.CompanyWebsite;
  const browserOrigin = typeof window !== 'undefined' && window.location
    ? window.location.origin
    : null;
  const origin = browserOrigin || configuredOrigin || `https://${firebase.config.projectId}.web.app`;
  const response = await fetch(origin + path, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data.error || 'BOOKING_API_ERROR');
    error.status = response.status;
    throw error;
  }
  return data;
};

export const searchServerBookingCustomers = async (query) =>
  callBookingApi(`/api/booking/customers?q=${encodeURIComponent(query)}`);

export const requestServerBookingQuote = async (request) =>
  callBookingApi('/api/booking/quote', 'POST', request);

export const createServerBooking = async (request) =>
  callBookingApi('/api/booking/create', 'POST', request);

export const requestBookingWorkflow = async (request) =>
  callBookingApi('/api/booking/workflow', 'POST', request);
